<section class="workbench">

  <!-- Header -->
  <header class="wb-header">
    <div>
      <h2 class="wb-title">{{ title }}</h2>
      <p class="wb-desc" *ngIf="description">{{ description }}</p>
    </div>
    <div class="wb-header-actions">
      <button type="button" class="wb-btn wb-btn-ghost" (click)="loadItems()" [disabled]="loading" title="Refresh">
        <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
          <path d="M23 4v6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1 20v-6h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Refresh
      </button>
      <button type="button" class="wb-btn wb-btn-primary" (click)="startCreate()">
        <svg viewBox="0 0 24 24" fill="none" width="15" height="15">
          <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
        New Item
      </button>
    </div>
  </header>

  <!-- Feedback -->
  <div class="wb-feedback wb-feedback--success" *ngIf="message">
    <svg viewBox="0 0 24 24" fill="none" width="15" height="15" style="flex-shrink:0">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      <path d="M22 4L12 14.01l-3-3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    {{ message }}
  </div>
  <div class="wb-feedback wb-feedback--error" *ngIf="error">
    <svg viewBox="0 0 24 24" fill="none" width="15" height="15" style="flex-shrink:0">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
      <path d="M12 8v4m0 4h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
    {{ error }}
  </div>

  <!-- Loading -->
  <div class="wb-loading" *ngIf="loading">
    <div class="wb-spinner"></div>
    <span>Loading…</span>
  </div>

  <!-- Empty state -->
  <div class="wb-empty" *ngIf="!loading && items.length === 0">
    <svg viewBox="0 0 24 24" fill="none" width="36" height="36">
      <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.5"/>
      <path d="M8 21h8M12 17v4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
    <p>No items yet. Click <strong>New Item</strong> to add one.</p>
  </div>

  <!-- Item cards -->
  <ul class="wb-cards" *ngIf="!loading && items.length > 0">
    <li class="wb-card" *ngFor="let item of items" [class.wb-card--selected]="isSelected(item)">
      <div class="wb-card-body">
        <span class="wb-card-label">{{ itemLabel(item) }}</span>
        <span class="wb-card-id">ID: {{ item['id'] }}</span>
      </div>
      <button type="button" class="wb-card-edit-btn" (click)="selectItem(item)">
        <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Edit
      </button>
    </li>
  </ul>

</section>

<!-- Drawer backdrop -->
<div class="wb-backdrop" *ngIf="selectedId || createMode" (click)="closeDrawer()"></div>

<!-- Edit / Create drawer -->
<aside class="wb-drawer" *ngIf="selectedId || createMode">
  <header class="wb-drawer-header">
    <div>
      <p class="wb-drawer-eyebrow">{{ title }}</p>
      <h3 class="wb-drawer-title">{{ createMode ? 'New Item' : 'Edit Item' }}</h3>
    </div>
    <button type="button" class="wb-close-btn" (click)="closeDrawer()">
      <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </header>

  <form class="wb-drawer-body" (ngSubmit)="save()">
    <div class="wb-fields">
      <label class="wb-field" *ngFor="let field of fields">
        <span class="wb-field-label">{{ field.label }}</span>

        <textarea
          *ngIf="field.type === 'textarea' || field.type === 'json'"
          [name]="field.key"
          [(ngModel)]="form[field.key]"
          [rows]="field.type === 'json' ? 8 : 4"
          class="wb-input"
        ></textarea>

        <input
          *ngIf="field.type !== 'textarea' && field.type !== 'json' && field.type !== 'boolean'"
          [name]="field.key"
          [(ngModel)]="form[field.key]"
          [type]="field.type === 'number' ? 'number' : field.type === 'datetime' ? 'datetime-local' : field.type === 'date' ? 'date' : 'text'"
          class="wb-input"
        />

        <input
          *ngIf="field.type === 'boolean'"
          [name]="field.key"
          [(ngModel)]="form[field.key]"
          type="checkbox"
          class="wb-checkbox"
        />
      </label>
    </div>

    <div class="wb-drawer-feedback wb-feedback--success" *ngIf="message">{{ message }}</div>
    <div class="wb-drawer-feedback wb-feedback--error" *ngIf="error">{{ error }}</div>

    <footer class="wb-drawer-footer">
      <button
        type="button"
        class="wb-btn wb-btn-danger"
        *ngIf="!createMode && selectedId"
        [disabled]="deleting"
        (click)="deleteSelected()"
      >
        {{ deleting ? 'Deleting…' : 'Delete' }}
      </button>
      <div class="wb-footer-right">
        <button type="button" class="wb-btn wb-btn-ghost" (click)="closeDrawer()">Cancel</button>
        <button type="submit" class="wb-btn wb-btn-primary" [disabled]="saving">
          {{ saving ? 'Saving…' : createMode ? 'Create' : 'Save Changes' }}
        </button>
      </div>
    </footer>
  </form>
</aside>

<!-- Delete confirm dialog -->
<div class="wb-overlay" *ngIf="confirmDialogOpen" (click)="closeConfirmDialog()">
  <article class="wb-dialog" (click)="$event.stopPropagation()">
    <header class="wb-dialog-header">
      <h3>Delete item?</h3>
      <button type="button" class="wb-close-btn" (click)="closeConfirmDialog()">
        <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
          <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </header>
    <p class="wb-dialog-body">Are you sure you want to delete this item? This action cannot be undone.</p>
    <div class="wb-dialog-actions">
      <button type="button" class="wb-btn wb-btn-ghost" (click)="closeConfirmDialog()" [disabled]="deleting">Cancel</button>
      <button type="button" class="wb-btn wb-btn-danger" (click)="confirmDeleteSelected()" [disabled]="deleting">
        {{ deleting ? 'Deleting…' : 'Delete Item' }}
      </button>
    </div>
  </article>
</div>
